import React from 'react';
import { TreeSelect as AntTreeSelect } from 'antd';
import { ChevronDown } from '@nackle/origami-icons';

/**
 * A tree select that extends Ant Design's Tree select
 *
 * {@link https://ant.design/components/tree-select#tree-props }
 *
 * @module TreeSelect
 * @param {Object} props - the component props
 * @param {React.ReactElement} [props.switcherIcon] - the icon to display for the switcher
 * @param {React.ReactElement} [props.suffixIcon] - the icon to display for the suffix
 * @param {string} [props.type] - the typ eof tree select (radio or checkbox)
 * @returns {React.ReactElement} - The rendered tree select component
**/
const TreeSelect = ( { ...props } ) => {

    const iconProp = ChevronDown;

    props.switcherIcon = iconProp;
    props.suffixIcon = <ChevronDown/>;

    return (
        <AntTreeSelect { ...props } ></AntTreeSelect>
    );
};
TreeSelect.Checkable = ( { children, ...props } ) => {
    const { type } = props;
    props.suffixIcon = <ChevronDown/>;
    return (
        <div>
            { type === 'checkbox' &&
                <AntTreeSelect { ...props }></AntTreeSelect>
            }
            {
                type === 'radio' &&
                <AntTreeSelect popupClassName='select-radio' { ...props } ></AntTreeSelect>
            }
        </div>
    );
};

export { TreeSelect };
